<template>
  <LazyHydrate when-idle>
    <ProductTopCard :details="topCardData">
      <template #title>
        <h1
          class="font-extrabold just-desktop text-2xl mb-5 text-start text-blue-500"
        >
          {{ topCardData.title }}
        </h1>
        <div class="font-extrabold just-mobile mb-5 text-center text-blue-500">
          <div class="text-xl mb-1">{{ topCardData.title }}</div>
          <div class="text-base">{{ topCardData.subtitle }}</div>
        </div>
      </template>
    </ProductTopCard>
  </LazyHydrate>

  <LazyHydrate when-visible>
    <BaseSecondCard :details="secondCardData" />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <section class="gridClass mt-16">
      <div class="text-center font-bold">
        <div class="mb-4 laptop:mb-10">
          <h2 class="text-base laptop:text-2xl">
            مزایای اپلیکیشن اختصاصی نواتل
          </h2>
        </div>
        <section class="grid grid-cols-2 laptop:grid-cols-3 gap-x-4 gap-y-10">
          <ProductAdvantage
            v-for="item in advantages"
            :key="item.id"
            :item="item"
          />
        </section>
      </div>
    </section>
  </LazyHydrate>

  <LazyHydrate when-visible>
    <div class="gridClass mt-16">
      <ProductSecondCard :data="grayCardData" showTik />
    </div>
  </LazyHydrate>

  <LazyHydrate when-visible>
    <section class="gridClass mt-20">
      <div class="mb-4 laptop:mb-10">
        <h3 class="text-center font-bold text-base laptop:text-2xl">
          امکانات اپلیکیشن اختصاصی نواتل
        </h3>
      </div>
      <div class="just-desktop">
        <div class="grid grid-cols-1 laptop:grid-cols-2 gap-4">
          <ProductPossibility
            v-for="item in possibilities"
            :key="item.id"
            :item="item"
          />
        </div>
      </div>
      <div class="just-mobile">
        <div class="grid grid-cols-1 laptop:grid-cols-2 gap-4">
          <ProductPossibility :item="allPossibilities" />
        </div>
      </div>
    </section>
  </LazyHydrate>

  <LazyHydrate when-visible>
    <SectionDownloadApp :details="appData" id="app_url" class="mt-20" />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <h3 class="text-center text-2xl font-bold pb-6 mt-16">نواتل در یک نگاه</h3>
    <SectionPossibilities />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <ProductMoreInformation
      :details="moreInfoData"
      class="mt-10 laptop:mt-32"
    />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <SectionQuestions :data="questionData" />
  </LazyHydrate>
</template>

<script setup>
const { navaApp } = useAppData()

useHead({
  title: "اپلیکیشن اختصاصی نواتل",
  meta: [
    {
      hid: "keywords",
      name: "keywords",
      content:
        "اپلیکیشن اختصاصی, دانلود نواتل, نصب نواتل, پیام رسان نواتل, اپلیکیشن نواتل, برنامه نواتل, دانلود برنامه نواتل, دانلود اپلیکیشن نواتل, نصب برنامه نواتل, به روز رسانی نواتل, اپلیکیشن اختصاصی ارتباطات یکپارچه, اپلیکیشن اختصاصی تلفن ابری, اپلیکیشن اختصاصی تلفن اینترنتی, ؟؟ آی پی فون- اپلیکیشن تلفن- تلفن نرم  افزاری – تلفن تحت وب- وب فون-تلفن ویپ – تلفن voip – اپ مرکز تماس – اپ مرکز تلفن – سافت فون اختصاصیدفتر کار مجازی",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://navatel.ir/products/dedicated-application/",
    },
  ],
});

const isModalShow = ref(false);

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};

const topCardData = {
  id: "1",
  title: "اپلیکیشن اختصاصی نواتل",
  subtitle: "همه‌چیز در کنترل شماست",
  desc: `نواتل به منظور جلب رضایت مشتریان خود یک اپلیکیشن اختصاصی طراحی کرده است که کاربران با استفاده از آن به راحتی می‌توانند تلفن ابری یا هر سرویسی را که از این مجموعه معتبر ارائه دهنده خدمات تلفن‌های اینترنتی تهیه کرده‌اند مدیریت کنند. اپلیکیشن اختصاصی نواتل مدیریت ارتباطات کسب و کار را در هر زمان و هر مکانی تسهیل می‌کند.`,
  img: "/img/product/application.webp",
  // imgClass: "!w-[80%] laptop:!w-[60%] mx-auto",
  // firstButton: {
  //   text: "دمو و مشاوره رایگان",
  //   modalId: "main",
  //   styleType: "primary",
  // },
  // secondButton: {
  //   text: "مشاهده قیمت‌ها",
  //   scrollTo: "fax_price",
  //   styleType: "secondary",
  // },
  firstButton: { text: "دانلود اپلیکیشن", scrollTo: "app_url" },
  secondButton: {
    text: "مشاوره رایگان ",
    modalId: "main",
    styleType: "secondary",
  },
};

const secondCardData = {
  videoImg: {
    img: "/img/app.webp",
    video: "/video/app.mp4",
    // classess: "!rounded-none border-0",
    // isWhiteBtn: true,
  },
  alt: "کاور اپلیکیشن اختصاصی",
};

const advantages = [
  {
    id: 0,
    title: "دریافت اعلان",
    text: "اپلیکیشن اختصاصی نواتل اعلان‌های مختلف مربوط به سرویس کاربران را به صورت لحظه‌ای به آن‌ها اعلام می‌کند به این ترتیب کاربران از تماس‌ها و پیام‌های خود مطلع می‌شوند.",
    icon: "15",
  },
  {
    id: 1,
    title: "دفترچه تلفن",
    text: "اپلیکیشن نواتل دارای دفترچه تلفن است که کاربران با استفاده از آن می‌توانند لیستی از مخاطبان خود برای برقراری تماس و ارسال پیام و یا برگزاری ویدئو کنفرانس داشته باشند.",
    icon: "contactsBook",
  },
  {
    id: 2,
    title: "هلد و ترنسفر تماس",
    text: "امکان ترنسفر یا قابلیت انتقال تماس‌ها از یک بخش سازمان به بخش دیگر، کافی است اپراتور، تماس ورودی را هلد کرده و آن را به بخش دیگری از سازمان که می‌خواهد منتقل کند.",
    icon: "18",
  },
  {
    id: 3,
    title: "کیف پول اختصاصی",
    text: "از طریق اپلیکیشن نواتل امکان پرداخت هزینه‌های سرویس‌ها با کیف پول اختصاصی آن فراهم شده‌است به این ترتیب می‌توان به سادگی و سرعت هزینه تماس‌ها را مدیریت نمود.",
    icon: "35",
  },
  {
    id: 4,
    title: "تماس صوتی و تصویری",
    text: "کاربران با استفاده از اپلیکیشن جذاب و کاربردی نواتل  می‌توانند با یکدیگر تماس صوتی یا تصویری برقرار کنند و یا حتی به صورت آنلاین ویدئو کنفرانس و جلسات گروهی برگزار نمایند.",
    icon: "03",
  },
  {
    id: 5,
    title: "پشتیبانی",
    text: "با استفاده از اپلیکیشن کاربران می‌توانند به راحتی با بخش پشتیبانی نواتل ارتباط برقرار کنند و به کمک متخصصین مجرب این مجموعه، مشکلاتی که برای بهره‌مندی از تلفن ابری یا هر سرویس دیگری با آن مواجه می‌شوند را  برطرف کنند.",
    icon: "support",
  },
];

const grayCardData = {
  title: "اپلیکشن اختصاصی نواتل؛ منحصر بفرد برای کسب‌وکارها",
  img: "/img/product/application2.webp",
  options: [
    {
      id: 1,
      text: "اپلیکیشن اختصاصی نواتل با طراحی کاربرمحور و کاربردی و امکانات متنوع ارتباطات سازمان شما را تسهیل می‌کند.",
    },
    {
      id: 2,
      text: "ارتباط مستقیم با مشتریان، دریافت سوالات، مشکلات و نظرات آن‌ها و ارائه پشتیبانی مورد نیاز به صورت 24 ساعته.",
    },
    {
      id: 3,
      text: "امنیت بسیار بالا، حفاظت از اطلاعات مشتریان و تراکنش‌های آن‌ها و جلوگیری از دسترسی غیرمجاز.",
    },
    {
      id: 4,
      text: "بازاریابی و ارتقا کسب و کار، با ایجاد گروه و کانال در اپلیکیشن بازاریابی انجام دهید، تخفیف‌ها و اخبار خود را به اطلاع مشتریان برسانید و به این ترتیب منحنی فروش خود را صعودی کنید.",
    },
  ],
};

const possibilities = [
  {
    id: "1",
    list: [
      {
        text: "اپلیکیشن اختصاصی اندروید با نصب آسان و طراحی کاربر محور",
        icon: "16",
      },
      {
        text: "دارای همه امکانات یک پیام رسان مانند چت، ساخت گروه و کانال",
        icon: "82",
      },
      {
        text: " امکان اشتراک گذاری فایل‌ها واطلاعات مورد نیاز و ذخیره پیام‌ها ",
        icon: "102",
      },
    ],
  },
  {
    id: "2",
    list: [
      {
        text: "امکان پرداخت هزینه‌های سرویس‌ها با کیف پول اختصاصی نواتل",
        icon: "35",
      },
      {
        text: "قابلیت نصب روی چندین دستگاه مختلف و مدیریت بهینه ارتباطات",
        // icon: "devices",
        icon: "supporter",
      },
      {
        text: "امکان استفاده با هر اینترنتی بدون نیاز به اینترنت با سرعت خیلی بالا ",
        icon: "19",
      },
    ],
  },
];

const allPossibilities = computed(() => {
  const items = [];
  possibilities.forEach((element) => {
    items.push(...element.list);
  });
  return {
    id: "0",
    list: items,
  };
});

const appData = computed(() => ({
  title: "دانلود اپلیکیشن ",
  items: navaApp.value
}));

const moreInfoData = {
  id: "1",
  title: "درباره نواتل بیشتر بدانید",
  items: [
    {
      id: "1",
      text: "سرویس ارتباطات یکپارچه (UCaaS) نواتل",
      img: "/img/articles/app1.webp",
      url: `https://navatel.ir/blog/ucaas/`,
    },
    {
      id: "2",
      text: "سافت فون نواتل دستیار تلفنی هوشمند + معرفی و دانلود 1+5 سافت فون کاربردی",
      img: "/img/articles/app2.webp",
      url: `https://navatel.ir/blog/softphone-%d9%86%d9%88%d8%a7%d8%aa%d9%84/`,
    },
    {
      id: "1",
      text: "مزایا و معایب دفتر مجازی و هرآنچه باید بدانید",
      img: "/img/articles/app3.webp",
      url: `https://navatel.ir/blog/%d9%85%d8%b2%d8%a7%db%8c%d8%a7-%d9%88-%d9%85%d8%b9%d8%a7%db%8c%d8%a8-%d8%af%d9%81%d8%aa%d8%b1-%d9%85%d8%ac%d8%a7%d8%b2%db%8c/`,
    },
  ],
};

const questionData = {
  title: "سؤالات متداول اپلیکیشن اختصاصی نواتل",
  items1: [
    {
      title: "قابلیت‌های اصلی اپلیکیشن نواتل چیست؟",
      text: "قابلیت‌های اصلی اپلیکیشن نواتل شامل پیامرسان یک به یک، گروه، کانال‌های اطلاع‌رسانی، سرویس دفترچه تلفن، ویدئوکنفرانس و دریافت تمامی تماس‌های مرکز تلفن بر روی اپلیکیشن است.",
    },
  ],
  items2: [
    {
      title: "آیا قابلیت نصب نرم افزار بر روی مک و لینوکس وجود دارد؟",
      text: "بله، با استفاده از نسخه تحت وب، نواتل قابلیت استفاده روی کلیه‌ی سیستم‌های عامل را دارد. شما می‌توانید نسخه تحت وب این اپلیکیشن را از سایت نواتل دانلود کرده و روی سیستم خود نصب کنید.",
    },
  ],
};
</script>
